// Normalizers convert whatever value the user has entered into the value that
// you want stored in the Redux store for the field.

import { YYYYtoIso8061 } from '../date';

/**
 * Normalizes dates used for education form fields.
 *
 * @param {String} value Date, entered as YYYY, normalized as YYYY-MM-DD.
 */
export const normalizeEducationDate = YYYYtoIso8061;

/**
 * Normalizes dates used for experience form fields.
 *
 * @param {String} value Date, entered as MMYYYY, normalized as YYYY-MM-DD.
 * @param {String} previousValue The previous value for the field.
 */
export const normalizeExperienceDate = (value, previousValue) => {
  if (!value) { return value; }

  const onlyNums = value.replace(/[^\d]/g, '');

  // reset "Current" to empty string
  if (!onlyNums.length) { return ''; }

  // skip slash when backspacing
  if (previousValue === `${value}/`) { return onlyNums.slice(0, 1); }

  // If value is anyhting besides a 0 or 1, add a 0 to the beginning of the
  // number and then the slash.
  // (example: change "5" to "05/". If "0" or "1", do nothing.)
  if (onlyNums.length < 2) {
    const digit = parseInt(onlyNums);

    // If "0" or "1", do nothing.
    if (digit < 2) {
      return onlyNums;
    }

    // change "5" to "05/"
    return `0${onlyNums}/`;
  }

  if (onlyNums.length === 2) {
    const month = parseInt(onlyNums);

    // prevent month numbers over 12
    if (month > 12) { return onlyNums.slice(0, 1); }

    // automatically add slash after 2 numbers
    return `${onlyNums}/`;
  }

  // ignore incomplete values
  if (onlyNums.length < 6) { return value; }

  // normalize to YYYY-MM-DD
  return `${onlyNums.slice(2, 6)}-${onlyNums.slice(0, 2)}-01`;
};

/**
 * Normalizes dates used for license/certifcation form fields.
 *
 * @param {String} value Date, entered as YYYY, normalized as YYYY-MM-DD.
 */
export const normalizeLicenseCertDate = YYYYtoIso8061;

/**
 * Normalizes veteran value into a boolean or null for form fields.
 *
 * @param {String} value
 */
export const normalizeVeteran = (value) => (value === '' ? null : value === 'true');

/**
 * Cast is_veteran to a Boolean if it is a string
 * Disclaimer: I don't know exactly why this is necessary, but @ryans mentioned JS-3679
 * @param {*} value
 */
export const normalizeVeteranPatch = (value) => (typeof value === 'string' ? normalizeVeteran(value) : value);
